import axios from '@/plugins/axios/https';

export function ApiConditionPool() {
  return axios.get('/filtrations/condition-pool/');
}

export function ApiFiltrationsList({ search, limit, offset }) {
  const form = {
    search,
    limit,
    offset
  };

  return axios.get('/filtrations/templates/', form);
}

export function ApiFiltrationsProfile({ uuid }) {
  return axios.get(`/filtrations/${uuid}/profile/`);
}

export function ApiFiltrationSave({ uuid, data }) {
  const form = {
    data
  };
  return axios.post(`/filtrations/${uuid}/save/`, form);
}

export function ApiFiltrationFetch({ uuid, data }) {
  const form = {
    data
  };
  return axios.post(`/filtrations/${uuid}/fetch/`, form);
}

export function ApiFiltrationsInfo({ uuid }) {
  return axios.get(
    `/filtrations/${uuid}/fetch-info/`,
    {},
    {
      loading: false
    }
  );
}

export function ApiFiltrationsResult({ loading, search, uuid, limit, offset }) {
  const form = {
    search,
    limit,
    offset
  };

  return axios.get(`/filtrations/${uuid}/fetch-result/`, form, {
    loading
  });
}

export function ApiFiltrationCreate({ name, type }) {
  const form = {
    name
  };

  if (type) {
    form.type = type;
  }

  return axios.post('/filtrations/templates/create/', form);
}

export function ApiFiltrationDelete({ uuid }) {
  return axios.post(`/filtrations/templates/${uuid}/delete/`);
}

export function ApiFiltrationLock({ uuid }) {
  return axios.post(`/filtrations/${uuid}/lock/`);
}

export function ApiFiltrationUnLock({ uuid }) {
  return axios.post(`/filtrations/${uuid}/unlock/`);
}
